export const broadcastEvents = {
  focusEditor: 'focus-editor',
  editorHasFocus: 'editor-has-focus',
  focusSmartResponses: 'focus-smart-responses',
  sendMessage: 'send-message',
  focusKeyboardShortcutsPanel: 'focus-keyboard-shortcuts-panel',
  fileUploadOpened: 'file-upload-opened'
};
